module.exports = __webpack_public_path__ + "static/media/22_negro.bfd20735.svg";